import API, { responseOf } from "./base";
import type { FileUploadResponse } from "../transfer/FileUploadResponse";

export const uploadFile = (
  fileArray: FileList,
): Promise<FileUploadResponse[]> =>
  responseOf(API.post("/files/", fileArray, { public: true }));

// can't name a variable 'delete'
export const deleteFile = async (key: string): Promise<void> => {
  await API.delete(`/files/${key}`);
};
